import React, { Component } from 'react';
import OtpInput from 'react-otp-input';
import Recaptcha from 'react-recaptcha';
import '../../public/css/media/_otp.scss';
import store, { history } from '../store';
import { sendOtp, signup } from '../actions/Signup';
import { putReSendOTP, updateCustomerProfile } from '../actions/Signin';

class OneTimePassword extends Component {
  state = {
    otpValue: '',
    error: null,
    disabledLink: false,
    payload: null,
    time: 30,
    recaptcha: '',
  }
	componentWillMount(){
    if (localStorage.otp_response){
      this.setState({payload: JSON.parse(localStorage.getItem('otp_response'))})
    } else {
      history.goBack();
    }
    this.startTimer();
  }

  componentWillUnmount() {
    localStorage.removeItem('otp_response');
    localStorage.removeItem('otp_redirect');
    clearInterval(this.timer);
  }

  componentDidUpdate(prevProps){
  }

  componentWillReceiveProps(nextProps){
    let error = null;
    if (nextProps.login.sendOTPError !== this.props.login.sendOTPError){
      if (localStorage.getItem('otp_redirect') === 'signup') {
        error =  nextProps.login.sendOTPError && nextProps.login.sendOTPError.response && nextProps.login.sendOTPError.response.data.errors.detail.otp_code;
        this.setState({error});
      } else {
        error =  nextProps.login.sendOTPError && nextProps.login.sendOTPError.data && nextProps.login.sendOTPError.data.errors.detail.otp_code;
        this.setState({error});
      }
    }
    if (this.props.register.register !== nextProps.register.register){
      this.setState({payload: nextProps.register.register});
    }
    if (this.props.login.sendOTPSuccess !== nextProps.login.sendOTPSuccess){
      this.setState({payload: nextProps.login.sendOTPSuccess});
    }
  }

  handleInputChange(otpValue) {
    if (otpValue.match(/^[0-9]*$/)){
      this.setState({ otpValue, error: null });
    }
    return;
  }

  handleEnable(){
    if (this.state.otpValue){
      return false
    }
    return true
  }
  
  sendOtpCode(e) {
    e.preventDefault();
    //this.props.sendOtp(this.props.payload, this.state.otp);
    if (localStorage.getItem('otp_redirect') === 'signup'){
      store.dispatch(sendOtp(this.state.payload, this.state.otpValue));
    }
    if (localStorage.getItem('otp_redirect') === 'account'){
      store.dispatch(updateCustomerProfile(this.state.payload, this.state.otpValue));
    }
    if (localStorage.getItem('otp_redirect') === 'requiredModal'){
      this.props.addCustomerProfile(this.state.payload, this.state.otpValue);
    }
  }

  resendOtpCode(e) {
    e.preventDefault();
    if (localStorage.getItem('otp_redirect') === 'signup'){
      const copyPayload = {...this.state.payload}
      copyPayload.recaptcha = this.state.recaptcha;
      store.dispatch(signup(copyPayload));
    }
    if (localStorage.getItem('otp_redirect') === 'account'){
      store.dispatch(putReSendOTP(this.state.payload, null));
    }
    if (localStorage.getItem('otp_redirect') === 'requiredModal'){
      this.props.putReSendOTPRequired(this.state.payload);
    }
    this.startTimer();
  } 
  startTimer() {
    this.setState({ disabledLink: true });
     this.timer = window.setInterval(() => {
      this.setState({ time: this.state.time - 1 }, () => {
        if (this.state.time === 0) {
          this.setState({ time: 1, disabledLink: false });
          clearInterval(this.timer);
        }
      }); // <-- Change this line!
    }, 1000);
    if (this.state.time === 0) {
      this.setState({ time: 1, disabledLink: false });
      clearInterval(this.timer);
    }
  }
  verifyCallback(response) {
    this.setState({ recaptcha: response });
  }
  render(){
  return (
    <div>
      <div className="body-wrapper">
        <div id="shippingcart_app" className="header-original">
          <div className="otp-header">
            <img src="https://cdn.shippingcart.com/img/sc-logo.png" alt=""/>
          </div>

          <div className="container otp-page-body">
            <div className="center">
              <h3>One-Time Password</h3>
            </div>
            <div className="otp-border">
              <form className="form-horizontal">
                <section className="modal-body">
                  <div className="control">
                    <p>
                      You will receive a one-time password (OTP) on your registered mobile number ending in {this.state.payload.phone_number && this.state.payload.phone_number.slice(this.state.payload.phone_number.length - 4)}
                    </p>
                    <OtpInput
                      onChange={otp => this.handleInputChange(otp)}
                      numInputs={6}
                      value={this.state.otpValue}
                      separator={<span>&nbsp;&nbsp;</span>}
                      shouldAutoFocus={true}
                      inputStyle="otp-input-style"
                      hasErrored={this.state.error !== null ? true : false}
                      errorStyle="otp-error-style"
                    />
                  </div>
                  {this.state.error ?<label className="inline-error-message" >{this.state.error}</label> : null}
                  <p>Did not receive one-time password (OTP)?</p>
                  {!this.state.disabledLink && localStorage.getItem('otp_redirect') === 'signup' && <Recaptcha sitekey="6Ld0ERUUAAAAAP_R4QOXrx2K-furHNW55cv26LGF"
                    size="default" render="explicit"
                    verifyCallback={this.verifyCallback.bind(this)}
                    style={{margin: '10px'}}
                    // onChange={this.handleOnChange}
                  />}
                  <a className={this.state.disabledLink || (!this.state.recaptcha && localStorage.getItem('otp_redirect') === 'signup') ? "link-disabled" : ""} onClick={(e) => !this.state.disabledLink || (this.state.recaptcha && localStorage.getItem('otp_redirect') === 'signup') ? this.resendOtpCode(e) : ""}>
                    Resend {this.state.disabledLink ? 'after ' + this.state.time + ' seconds' : 'OTP'}
                  </a>
                </section>

                <div className="otp-footer">
                  <button type="submit" onClick={(e) => this.sendOtpCode(e)} className="sc-btn primary-btn" disabled={this.handleEnable()}>
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )}
}

export default OneTimePassword;



/** WEBPACK FOOTER **
 ** ./src/components/OneTimePassword.js
 **/